export default "__VITE_ASSET__f8899c74__"